import React from "react";

/**
 * Defines a base error message container that simply needs to be passed
 * an error text in order to render it nicely.
 */
// tslint:disable-next-line variable-name
export const BaseError: React.FC<{ errorMessage: React.ReactNode }> = (props) => {
    return (
        <div className="error">
            <div className="icon-container">
                <div className="icon" />
            </div>
            <p className="text">
                { props.errorMessage }
            </p>

            <style jsx>{`
                .error {
                    /** Position error in the middle of the page */
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: calc(100% - 80px);
                    margin: 0 40px;

                    /** Ensure content within is stacked vertically and centered horiontally */
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    & .icon-container {
                        /** Setup spacing between icon and error text */
                        margin-bottom: 30px;
                    }

                    & .icon {
                        position: relative;

                        /** Setup dimensions of error icon */
                        width: 80px;
                        height: 80px;

                        /** Render circle of icon */
                        border: 3px solid #dc4320;
                        border-radius: 50%;

                        &::before {
                            /** Render the "!" within the icon circle */
                            content: "!";
                            color: #dc4320;
                            font-size: 70px;
                            font-weight: 700;
                            line-height: 80px;

                            /** Center icon within circle */
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }

                    & .text {
                        /** Override defaults */
                        margin: 0;

                        /** Setup font */
                        text-align: center;
                        font-size: 22px;
                        line-height: 1.533;
                    }
                }
            `}</style>
        </div>
    );
};
